<style scoped>
    .form-leader{
        display: inline-block;
        border: 1px solid #dddee1;
        border-radius: 4px;
        padding: 4px 7px;
        line-height: 1.5;
    }
    .search-title{
        display: inline-block;
        margin-left: 20px;
    }
    .customer-search{
        display: inline-block;
    }
</style>
<template>
  <div>
    <div class="list-container">
      <Button
        type="primary"
        icon="md-add"
        @click="editCompany(new_company)"
      >
        添加公司
      </Button>
      <Table
        ref="table"
        border
        :columns="company_columns"
        :data="companies"
        :no-data-text="empty_tip"
        size="small"
      />
      <Backdrop v-show="loading" />
    </div>

    <Modal
      v-model="edit_config.modal"
      width="600"
      title="添加 / 修改"
      ok-text="保存"
      :loading="edit_config.loading"
      @on-ok="editOK"
    >
      <Form
        ref="companyForm"
        :model="editing_company"
        :label-width="80"
      >
        <Form-item
          label="全称"
          prop="name"
        >
          <i-input
            v-model="editing_company.name"
            placeholder="请输入"
          />
        </Form-item>
        <Form-item
          label="简称"
          prop="desc"
        >
          <i-input
            v-model="editing_company.short_name"
            placeholder="备注..."
          />
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>
<script route="/hr/company">
  import Util from '../../libs/util';
  export default {
    /* router_info_start */
    router_info: '/hr/company',
    /* router_info_end */

    data() {
      return {
        company_columns: [
          {
            title: '名称',
            key: 'name',
          },
          {
            title: '简称',
            key: 'short_name',
          },
          {
            title: '付款报销代码',
            key: 'company_code'
          },
          {
            title: '合同代码',
            key: 'contract_code'
          },
          {
            title: '操作',
            key: 'action',
            fixed: 'right',
            width: 120,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editCompany(params.row);
                    }
                  }
                }, '修改')
              ]);
            }
          }
        ],
        companies: [],
        empty_tip: '获取数据中...',
        loading: false,
        edit_config: {
          modal: false,
          loading: true
        },
        new_company: {
          name: '',
          short_name: '',
          desc: ''
        },
        editing_company: {},
      }
    },
    computed: {
      //
    },
    created() {
      this.getCompanys();
    },
    methods: {
      getCompanys() {
        if (!this.loading) {
          this.loading = true;
          this.empty_tip = '获取数据中...';
          Util.ajax.get(Util.api.get_companies_path, {

          }).then((response) => {
            return response.data;
          }).then((res) => {
            this.loading = false;
            if (res.code === 1) {
              const data = res.data;
              this.handleCompanys(data);
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.loading = false;
            this.empty_tip = '获取数据失败, 请刷新页面重试';
            console.log(e);
          });
        }
      },
      handleCompanys(companies) {
        companies.forEach((company) => {
          this.companies.push(company);
        })
      },
      editCompany(company) {
        if (company.id) {
          this.editing_company = Util.clone(company);
        } else {
          this.editing_company = company;
        }
        this.$nextTick(() => {
          this.edit_config.modal = true;
          console.log(this.editing_company);
        })
      },
      editOK() {
        this.editing_company.name = this.editing_company.name.trim();
        let valid = true;
        if (!this.editing_company.name) {
          valid = false;
          this.$Message.error('名称不能为空');
        }
        if (!valid) {
          this.edit_config.loading = false;
          setTimeout(() => {
            this.edit_config.loading = true;
          }, 1);
          return;
        }
        Util.ajax.post(Util.api.company_update, this.editing_company).then((response) => {
          return response.data;
        }).then((res) => {
          this.edit_config.modal = false;
          this.err_msg = {};
          if (res.code === 1) {
            const data = res.data;
            Util.insertOrUpdateArrayItem(this.companies, data);
            this.$Message.success('提交成功!');
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.edit_config.loading = false;
          setTimeout(() => {
            this.edit_config.loading = true;
          }, 1);
          console.log(e);
        });
      }
    }
  }
</script>
